import type { ExplorationSecondary } from '../../types/exploration';
import { effectiveSecondary } from '../secondaryGrouping';
import { clusterGrouping } from './clusterGrouping';
import { noneGrouping } from './noneGrouping';
import { regionGrouping } from './regionGrouping';
import { tagGrouping } from './tagGrouping';
import type { GroupingModel } from './types';
import { withAccountGrouping } from './withAccountGrouping';

export const GROUPINGS: Record<'cluster' | 'region' | 'tag' | 'none', GroupingModel> = {
  cluster: clusterGrouping,
  region: regionGrouping,
  tag: tagGrouping,
  none: noneGrouping,
};

export function getGroupingModel(
  secondary: ExplorationSecondary,
  tagKey: string
): GroupingModel {
  const resolved = effectiveSecondary(secondary, tagKey);
  const base = GROUPINGS[resolved];
  return withAccountGrouping(base);
}

export type { GroupingModel, GroupingPathOptions, GroupingHierarchyOptions } from './types';
